/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OmBrandsResponse } from '../../models/om-brands-response';

export interface GetAllBrands$Params {
  'Active-Tenant-Identifier': string;
}

export function getAllBrands(http: HttpClient, rootUrl: string, params: GetAllBrands$Params, context?: HttpContext): Observable<StrictHttpResponse<OmBrandsResponse>> {
  const rb = new RequestBuilder(rootUrl, getAllBrands.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OmBrandsResponse>;
    })
  );
}

getAllBrands.PATH = '/om/brands';
